import React from "react";
import {
  FaCartPlus,
  FaBriefcaseMedical,
  FaHeadset,
  FaUserTie,
  FaUtensils,
} from "react-icons/fa6";
import { PiPlugsConnectedFill } from "react-icons/pi";
import { CiImport } from "react-icons/ci";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import { GrValidate } from "react-icons/gr";
import NutradSPIcon from "../../assets/img/nt logo smart pipe.png";
import Footer from "../Footer/Footer"
import Image from "react-bootstrap/Image";
import Col from "react-bootstrap/Col";

// assets
import AlbertsonsIcon from "../../assets/img/Albertsons-Logo-PNG-Transparent.png";

import AutoZoneIcon from "../../assets/img/AutoZone-Logo-500x313.png";

import AshleyIcon from "../../assets/img/Ashley-HomeStore-logo-500x281.png";

import BHIcon from "../../assets/img/B&H_Photo-Logo.wine.svg";
import TargetIcon from "../../assets/img/Target_logo.svg.png";
import KrogerIcon from "../../assets/img/FreshCart_Kroger_Lockup_-300x112.png";
import AmazonIcon from "../../assets/img/amazon-logo.png";
import WalmartIcon from "../../assets/img/Walmart_logo.svg.png";
import ShopifyIcon from "../../assets/img/Shopify-Logo.png";
import SheinIcon from "../../assets/img/Shein-logo.png";
import BigLotsIcon from "../../assets/img/Big_Lots_logo.jpeg";
import BNIcon from "../../assets/img/barnes-and-noble-logo-1024x683.jpg";
import BelkIcon from "../../assets/img/Belk_Logo_New500.jpg";
import BBIcon from "../../assets/img/Best_Buy_logo_2018.svg";
import CostcoIcon from "../../assets/img/Costco_Wholesale_logo_2010-10-26.svg.png";
import LowesIcon from "../../assets/img/LowesLogo_RGB.png";
import JDIcon from "../../assets/img/JD.com_logo.png";
import walgreensIcon from "../../assets/img/1485908_WAG_Signature_logo_RGB_750x208.png";
import wayfairIcon from "../../assets/img/Wayfair_logo.svg.png";
import wegmansIcon from "../../assets/img/wegmans-logo-300x108.png";
import weisIcon from "../../assets/img/Weis_Markets_logo.svg.png";
import winndixieIcon from "../../assets/img/Winn_Dixie_Logo.svg.png";
import zapposIcon from "../../assets/img/Zappos-Logo-500x313.png";
import BJsIcon from "../../assets/img/BJ's_Wholesale_Club-Logo.wine.png";
import SamsIcon from "../../assets/img/Sams-Club-Logo.png";
import usfoodsIcon from "../../assets/img/US_Foods_logo.svg.png";
import ultracartIcon from "../../assets/img/ultracart-new.jpg";
import valuIcon from "../../assets/img/2e2ddaeeb569d8ee52f3.webp";
import vendioIcon from "../../assets/img/3eedf88a670a9ffa751ee35e088bc716.gif.webp";
import vendIcon from "../../assets/img/Vend_(software)_logo.svg.png";
import vipoutletIcon from "../../assets/img/88183_sq.jpg";
import vitacostIcon from "../../assets/img/BrandCategoryPage_202307_BrandGrid_Vitacost_360x360B.png.avif";
import vitaminIcon from "../../assets/img/the-vitamin-shoppe-logo-vector.png";
import ultrabIcon from "../../assets/img/Ulta_Beauty_logo.svg.png";

import truevalueIcon from "../../assets/img/truvalue.webp";
import tractorIcon from "../../assets/img/tractor.png";
import tirerackIcon from "../../assets/img/TireRack.png.avif";
import michaelsIcon from "../../assets/img/michaels.png";
import homedepotIcon from "../../assets/img/homedepot.jpg";
import containerstoreIcon from "../../assets/img/the-container-store-2022-color.png";
import syscoIcon from "../../assets/img/Sysco-Logo.svg.png";
import stopshopIcon from "../../assets/img/stop-shop-logo-retail-brand-organization-shopping-logo-design-5ad7bcc041ae97.3718683115240880002691.jpg";
import stapelsIcon from "../../assets/img/staples-logo-69924DC13F-seeklogo.com.png";
import sorinaIcon from "../../assets/img/sorina.png";
import shopeeIcon from "../../assets/img/Shopee_logo.svg.png";
import searsIcon from "../../assets/img/Sears_Logo_1994.svg.png";
import safewayIcon from "../../assets/img/Safeway-Logo.png";
import giantIcon from "../../assets/img/Giant_Logo.png";
import rossIcon from "../../assets/img/Ross_Stores-Logo.wine.png";
import riteaidIcon from "../../assets/img/Rite-Aid-logo.png";
import reiIcon from "../../assets/img/rei-coop-500_4fb8b.jpg";
import qvcIcon from "../../assets/img/QVC-Logo.wine.png";
import publixIcon from "../../assets/img/Publix_Retail_Logo.png";
import petsmartIcon from "../../assets/img/PetSmart-Logo.wine.png";
import { GifIcon, HomeIcon } from "@heroicons/react/24/outline";

const Destinations = () => {
  const servicesData = [
    {
      icon: (
        <Image src={AlbertsonsIcon} width="120px" height="120px" alt="GDSN" />
      ),
      title: "Albertsons Connection",
      link: "/import",
      status: "Available",
    },
    {
      icon: (
        <Image src={AutoZoneIcon} width="120px" height="120px" alt="GDSN" />
      ),
      title: "AutoZone Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={AmazonIcon} width="120px" height="120px" alt="GDSN" />,
      title: "Amazon Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={AshleyIcon} width="120px" height="120px" alt="GDSN" />,
      title: "Ashley HomeStore Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={BNIcon} width="120px" height="120px" alt="GDSN" />,
      title: "Barnes and Noble Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={BelkIcon} width="120px" height="120px" alt="GDSN" />,
      title: "Belk Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={BBIcon} width="120px" height="120px" alt="GDSN" />,
      title: "Best Buy Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={BigLotsIcon} width="120px" height="120px" alt="GDSN" />,
      title: "Big Lots Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={BJsIcon} width="120px" height="120px" alt="GDSN" />,
      title: "BJs Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={BHIcon} width="120px" height="120px" alt="GDSN" />,
      title: "B&H Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={CostcoIcon} width="120px" height="120px" alt="GDSN" />,
      title: "COSTCO Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={giantIcon} width="120px" height="120px" alt="GDSN" />,
      title: "Giant Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: (
        <Image src={homedepotIcon} width="120px" height="120px" alt="GDSN" />
      ),
      title: "HomeDepot Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={JDIcon} width="120px" height="120px" alt="GDSN" />,
      title: "JD.com Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={KrogerIcon} width="120px" height="120px" alt="GDSN" />,
      title: "Kroger Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={LowesIcon} width="120px" height="120px" alt="GDSN" />,
      title: "Lowes Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: (
        <Image src={michaelsIcon} width="120px" height="120px" alt="GDSN" />
      ),
      title: "Michaels Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={SamsIcon} width="120px" height="120px" alt="GDSN" />,
      title: "Sams Club Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={SheinIcon} width="120px" height="120px" alt="GDSN" />,
      title: "SHEIN Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={ShopifyIcon} width="120px" height="120px" alt="GDSN" />,
      title: "Shopify Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={TargetIcon} width="120px" height="120px" alt="GDSN" />,
      title: "Target Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: (
        <Image
          src={containerstoreIcon}
          width="120px"
          height="120px"
          alt="GDSN"
        />
      ),
      title: "The Container Store Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: (
        <Image src={tirerackIcon} width="120px" height="120px" alt="GDSN" />
      ),
      title: "TireRack Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: (
        <Image src={truevalueIcon} width="120px" height="120px" alt="GDSN" />
      ),
      title: "TruValue Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={tractorIcon} width="120px" height="120px" alt="GDSN" />,
      title: "Tractor Supply Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={vitaminIcon} width="120px" height="120px" alt="GDSN" />,
      title: "The Vitamin Shoppe Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: (
        <Image src={vitacostIcon} width="120px" height="120px" alt="GDSN" />
      ),
      title: "VitaCost Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: (
        <Image src={vipoutletIcon} width="120px" height="120px" alt="GDSN" />
      ),
      title: "VIPOutlet Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={vendioIcon} width="120px" height="120px" alt="GDSN" />,
      title: "VENDIO Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={vendIcon} width="120px" height="120px" alt="GDSN" />,
      title: "Vend Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={valuIcon} width="120px" height="120px" alt="GDSN" />,
      title: "VALU Home Centers Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={ultrabIcon} width="120px" height="120px" alt="GDSN" />,
      title: "ULTA Beauty Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={usfoodsIcon} width="120px" height="120px" alt="GDSN" />,
      title: "US Foods Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: (
        <Image src={ultracartIcon} width="120px" height="120px" alt="GDSN" />
      ),
      title: "ULTRACart Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: (
        <Image src={walgreensIcon} width="120px" height="120px" alt="GDSN" />
      ),
      title: "Walgreens Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: (
        <Image src={WalmartIcon} width="120px" height="120px" alt="GDSN" />
      ),
      title: "Walmart Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={wayfairIcon} width="120px" height="120px" alt="GDSN" />,
      title: "Wayfair Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={wegmansIcon} width="120px" height="120px" alt="GDSN" />,
      title: "Wegmans Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={weisIcon} width="120px" height="120px" alt="GDSN" />,
      title: "Weis Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: (
        <Image src={winndixieIcon} width="120px" height="120px" alt="GDSN" />
      ),
      title: "WinnDixie Connection",
      link: "/products",
      status: "Available",
    },
    {
      icon: <Image src={zapposIcon} width="120px" height="120px" alt="GDSN" />,
      title: "Zappos Connection",
      link: "/products",
      status: "Available",
    },
  ];

  return (
    <div className="py-5 bg-light">
      <div className="container">
        <div className="mb-4">
          <h1 className="h3 fw-semibold mb-2">Available Destinations</h1>
          <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
            Connect your products to leading retail destinations
          </p>
        </div>

        <div className="row g-4">
          {servicesData.map((service, index) => (
            <div key={index} className="col-xl-3 col-lg-4 col-md-6">
              <div
                className="card h-100 border-0 bg-white"
                style={{
                  transition: "all 0.2s ease",
                  borderRadius: "12px",
                  overflow: "hidden",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 20px rgba(0,0,0,0.1)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div className="card-body p-4 d-flex flex-column">
                  <div
                    className="text-center mb-3"
                    style={{
                      height: "100px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "12px",
                    }}
                  >
                    {React.cloneElement(service.icon, {
                      style: {
                        maxWidth: "100px",
                        maxHeight: "100px",
                        objectFit: "contain",
                      },
                    })}
                  </div>

                  <h6
                    className="card-title text-center mb-2"
                    style={{
                      fontSize: "1rem",
                      fontWeight: "600",
                      color: "#2c3e50",
                    }}
                  >
                    {service.title}
                  </h6>

                  <div className="text-center mb-3">
                    <Badge
                      bg="success"
                      style={{
                        fontSize: "0.75rem",
                        fontWeight: "500",
                        padding: "0.35em 0.85em",
                        borderRadius: "20px",
                      }}
                    >
                      Available
                    </Badge>
                  </div>

                  <div className="mt-auto text-center">
                    <Button
                      variant="outline-primary"
                      disabled={true}
                      className="w-100"
                      style={{
                        fontSize: "0.85rem",
                        padding: "0.5rem",
                        borderRadius: "8px",
                        transition: "all 0.2s ease",
                      }}
                    >
                      Request
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Destinations;